import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as UploadIcon } from "../../../../../../assets/humbleicons_upload.svg";
import { useForm, Controller } from "react-hook-form";
import { Button } from "reactstrap";

const UploadRequiredDocument = ({
  onSubmit,
  lengthofTraveler,
  handleAdditionalFileChange,
  handleLuggageFileChange,
  familyMembers,
  handlePassportUpload,
  handleAdditionalUpload,
  handleBoardingUpload,
  removeFamilyMember,
  handleViewFile,
  boardingImg,
  passportImg,
  additionalImg,
  selectedAdditionalFiles,
  selectedLuggageFiles,
  setStepfive,
  selectBoardingFile,
  setSelectBoardingFile,

  selectPassportFile,
  setSelectPassportFile,
  type_of_claim
}) => {
  const { register, handleSubmit, setValue, watch } = useForm();

  // Get the current values (won't work properly for files)
  const boardingPassFile = watch("boarding_pass");
  const passportFile = watch("passport");

  const ACCEPTED_FILE_TYPES = [
    "application/pdf",
    "image/jpeg",
    "image/png",
    "image/heic",
    "image/heif",
    "image/webp",
    // Optional: 'text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ];

  // Add state for error messages
  const [boardingfileError, setBoardingFileError] = useState(null);
  const [PassportfileError, setPassportFileError] = useState(null);

  useEffect(() => {



    if (familyMembers.length > 0) {
      const allPassportsUploaded = familyMembers.every(
        (member) => member.passport !== null
      );


      if (type_of_claim === "lost/damaged" || type_of_claim === "lost_wages") {
        if (selectPassportFile && allPassportsUploaded && selectedLuggageFiles) {
          setStepfive(true);
        } else {
          setStepfive(false);

        }
      } else {
        if (selectPassportFile && allPassportsUploaded) {
          setStepfive(true);
        } else {
          setStepfive(false);

        }
      }

    } else {
      if (type_of_claim === "lost/damaged" || type_of_claim === "lost_wages") {
        if (selectPassportFile && selectedLuggageFiles) {
          setStepfive(true);
        } else {
          setStepfive(false);

        }
      } else {
        if (selectPassportFile) {
          setStepfive(true);
        } else {
          setStepfive(false);

        }
      }

    }


  }, [selectPassportFile, familyMembers, selectedLuggageFiles]);

  const handleBoardingPassChange = (e) => {
    const file = e.target.files[0];

    setSelectBoardingFile(file);
    // setBoardingFileError(null);

    // Case 1: No file selected
    // if (!file) {
    //   setMainBoardingFileName("");
    //   setValue("boarding_pass", null);
    //   return;
    // }

    // Case 2: Invalid file type
    // if (!ACCEPTED_FILE_TYPES.includes(file.type)) {
    //   setBoardingFileError(
    //     "Invalid file type. Please upload PDF, JPG, PNG, or HEIC."
    //   );
    //   e.target.value = ""; // Clear the invalid file
    //   setMainBoardingFileName("");
    //   setValue("boarding_pass", null);
    //   return;
    // }

    // Case 3: File too large (optional)
    // const MAX_SIZE = 5 * 1024 * 1024; // 5MB
    // if (file.size > MAX_SIZE) {
    //   setBoardingFileError("File too large. Maximum size is 5MB.");
    //   e.target.value = "";
    //   setMainBoardingFileName("");
    //   setValue("boarding_pass", null);
    //   return;
    // }

    // Case 4: Valid file
    // setMainBoardingFileName(file.name);
    // setValue("boarding_pass", e.target.files, { shouldValidate: true });
  };
  const handlePassportChange = (e) => {
    const file = e.target.files[0];
    setSelectPassportFile(file);
    // setPassportFileError(null);

    // Case 1: No file selected
    // if (!file) {
    //   setMainPassportFileName("");
    //   setValue("boarding_pass", null);
    //   return;
    // }

    // Case 2: Invalid file type
    // if (!ACCEPTED_FILE_TYPES.includes(file.type)) {
    //   setPassportFileError(
    //     "Invalid file type. Please upload PDF, JPG, PNG, or HEIC."
    //   );
    //   e.target.value = ""; // Clear the invalid file
    //   setMainPassportFileName("");
    //   setValue("boarding_pass", null);
    //   return;
    // }

    // Case 3: File too large (optional)
    // const MAX_SIZE = 5 * 1024 * 1024; // 5MB
    // if (file.size > MAX_SIZE) {
    //   setPassportFileError("File too large. Maximum size is 5MB.");
    //   e.target.value = "";
    //   setMainPassportFileName("");
    //   setValue("boarding_pass", null);
    //   return;
    // }

    // setMainPassportFileName(file?.name || "");
    // setValue("passport", e.target.files); // This is the key line
  };

  const handleFileChange = (event, setFileName) => {
    console.log(event.target.files.length)
    if (event.target.files.length > 0) {
      setFileName(event.target.files[0]?.name);
    } else {
      setFileName(null)
    }
  };



  const handleFormSubmit = (data) => {
    onSubmit(data);
  };

  // Separate states for each file input
  const [mainBoardingFileName, setMainBoardingFileName] = useState(null);
  const [mainPassportFileName, setMainPassportFileName] = useState(null);
  const [mainAdditionalFileName, setMainAdditionalFileName] = useState(null);
  const [mainLuggageFileName, setMainLuggageFileName] = useState(null);

  // For family members, we'll use an array of objects to track their file names
  const [familyFileNames, setFamilyFileNames] = useState(
    familyMembers.map(() => ({
      boarding: null,
      passport: null,
      additional: null,
    }))
  );

  // Update family file names when familyMembers changes
  // React.useEffect(() => {
  //   setFamilyFileNames(
  //     familyMembers.map(() => ({
  //       boarding: null,
  //       passport: null,
  //       additional: null,
  //     }))
  //   );
  // }, [familyMembers]);

  // Update your useEffect to preserve existing file names
  React.useEffect(() => {
    setFamilyFileNames((prev) => {
      const newFileNames = familyMembers.map((_, i) => ({
        boarding: prev[i]?.boarding || null,
        passport: prev[i]?.passport || null,
        additional: prev[i]?.additional || null,
      }));
      return newFileNames;
    });
  }, [familyMembers]);

  const handleFamilyFileChange = (event, index, type) => {
    if (event.target.files.length > 0) {
      const newFamilyFileNames = [...familyFileNames];
      newFamilyFileNames[index][type] = event.target.files[0].name;
      setFamilyFileNames(newFamilyFileNames);
    }
  };

  const getSubClaimFileName = (index, type) => {
    let fileName;
    if (type === "boarding_pass_file_name") {
      fileName = familyMembers[index][type]
        ? familyMembers[index][type]
        : familyMembers[index]["boarding_pass"]
          ? familyMembers[index]["boarding_pass"].split("/").pop()
          : "Upload File";
    }

    if (type === "passport_file_name") {
      fileName = familyMembers[index][type]
        ? familyMembers[index][type]
        : familyMembers[index]["passport"]
          ? familyMembers[index]["passport"].split("/").pop()
          : "Upload File";
    }

    if (type === "addtional_file_name") {
      fileName = familyMembers[index][type]
        ? familyMembers[index][type]
        : familyMembers[index]["additional_doc"]
          ? familyMembers[index]["additional_doc"].split("/").pop()
          : "Upload File";
    }

    return fileName;
  };

  const getFileName = (type) => {
    let fileName;
    if (type === "boarding_pass") {
      fileName = selectBoardingFile
        ? selectBoardingFile.name
        : boardingImg && boardingImg !== "undefined"
          ? boardingImg.split("/").pop()
          : "Upload File";
    }

    if (type === "passport") {
      fileName = selectPassportFile
        ? selectPassportFile.name
        : passportImg && passportImg !== "undefined"
          ? passportImg.split("/").pop()
          : "Upload File";
    }

    // if (type === "addtionalFile") {
    //   fileName = selectedAdditionalFiles
    //     ? Array.from(selectedAdditionalFiles)
    //         .map((file) => file.name)
    //         .join("  ")
    //     : additionalImg && additionalImg !== "undefined"
    //     ? additionalImg
    //         .map((file) => file?.document.split("/").pop())
    //         .join("  ")
    //     : "Upload File";
    // }

    console.log("additional documnet ===========> ", additionalImg);
    if (type === "addtionalFile") {
      console.log(selectedAdditionalFiles)
      fileName = selectedAdditionalFiles && selectedAdditionalFiles?.length > 0
        ? selectedAdditionalFiles[0]?.name
        : additionalImg &&
          additionalImg.length > 0 &&
          additionalImg !== "undefined"
          ? additionalImg[0].document.split("/").pop()
          : "Upload File";
    }

    if (type === "luggageFile") {
      fileName = selectedLuggageFiles
        ? selectedLuggageFiles?.name
        // : additionalImg &&
        //   additionalImg.length > 0 &&
        //   additionalImg !== "undefined"
        // ? additionalImg[0].document.split("/").pop()
        : "Upload File";
    }

    return fileName;
  };

  return (
    <div className="stepper-container">
      <div className="stepper-header-container">
        <h3 className="stepper-header" style={{ margin: 0 }}>
          Upload required documents
        </h3>
      </div>
      <div>
        <h4 className="stepper-sub-header" style={{ marginBottom: "5px" }}>
          Upload the following documents for each passenger
        </h4>
      </div>
      <form onSubmit={handleSubmit(handleFormSubmit)} id="upload-document-form">
        <div style={{ display: "flex", flexDirection: "column", gap: "35px" }}>
          <div className="file-a-claim">
            <h6 className="form-sub-header">
              Supported formats: PDF, DOCX, JPG. Max size: 10 MB.
            </h6>

            <div className="grid-two">
              <div className="custom-input" style={{ width: "100%" }}>
                <label className="input-label">Boarding pass</label>
                <input
                  id="boarding_pass"
                  type="file"
                  name="boarding_pass"
                  onChange={handleBoardingPassChange}
                  accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,.webp"
                  className="hidden"
                />
                <div
                  onClick={() =>
                    document.getElementById("boarding_pass").click()
                  }
                  className="input-box"
                  style={{
                    color: mainBoardingFileName ? "#222222" : "#7b8287",
                  }}
                >
                  {getFileName("boarding_pass")}

                  {/* {mainBoardingFileName ||
                    boardingImg.split("/").pop() ||
                    "Upload file"} */}
                  <UploadIcon />
                </div>

                {/* Show error message */}
                {boardingfileError && (
                  <p className="error-message">{boardingfileError}</p>
                )}

                {/* Help text */}
                <p className="file-help-text">
                  Accepted formats: PDF, JPG, PNG, HEIC (Max 5MB)
                </p>
              </div>
              <div className="custom-input" style={{ width: "100%" }}>
                <label className="input-label">Passport <span style={{ color: "#de8385" }}>*</span></label>
                <input
                  id="passport"
                  type="file"
                  name="passport"
                  onChange={handlePassportChange}
                  className="hidden"
                  accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,.webp"
                />
                <div
                  onClick={() => document.getElementById("passport").click()}
                  className="input-box"
                  style={{
                    color: mainPassportFileName ? "#222222" : "#7b8287",
                  }}
                >
                  {getFileName("passport")}
                  {/* {mainPassportFileName ||
                    passportImg.split("/").pop() ||
                    "Upload file"} */}
                  <UploadIcon />
                </div>

                {/* Show error message */}
                {PassportfileError && (
                  <p className="error-message">{PassportfileError}</p>
                )}
              </div>
            </div>

            <div className="grid-two" style={{ alignItems: "flex-end" }}>
              <div className="custom-input" style={{ width: "100%" }}>
                <label className="input-label">
                  {" "}
                  {(type_of_claim === "lost/damaged" || type_of_claim === "lost_bages") ? "Claim supporting documents and receipts" : "Additional claims documents"}
                </label>
                <input
                  id="additional"
                  type="file"
                  multiple
                  onChange={(e) => {
                    handleAdditionalFileChange(e);
                    handleFileChange(e, setMainAdditionalFileName);
                  }}
                  accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,.webp"
                  className="hidden"
                />
                <div
                  onClick={() => document.getElementById("additional").click()}
                  className="input-box"
                  style={{
                    color: mainAdditionalFileName ? "#222222" : "#7b8287",
                  }}
                >
                  {getFileName("addtionalFile")}
                  {/* {mainAdditionalFileName ||
                    additionalImg.split("/").pop() ||
                    "Upload file"} */}
                  <UploadIcon />
                </div>
              </div>
              {(type_of_claim === "lost/damaged" || type_of_claim === "lost_wages") &&
                <div className="custom-input" style={{ width: "100%" }}>
                  <label className="input-label">
                    {" "}
                    Luggage claim receipt filed in airport with the lost and found office or airline <span style={{ color: "#de8385" }}>*</span>
                  </label>
                  <input
                    id="luggage"
                    type="file"

                    onChange={(e) => {
                      handleLuggageFileChange(e);
                      handleFileChange(e, setMainLuggageFileName);
                    }}
                    accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,.webp"
                    className="hidden"
                  />
                  <div
                    onClick={() => document.getElementById("luggage").click()}
                    className="input-box"
                    style={{
                      color: mainLuggageFileName ? "#222222" : "#7b8287",
                    }}
                  >
                    {getFileName("luggageFile")}
                    {/* {mainAdditionalFileName ||
                    additionalImg.split("/").pop() ||
                    "Upload file"} */}
                    <UploadIcon />
                  </div>
                </div>
              }
            </div>

            {familyMembers.length > 0 && <h4
              className="stepper-sub-header"
              style={{ marginBottom: "5px", marginTop: "30px" }}
            >
              Additional passenger
            </h4>

            }

            {familyMembers.length > 0 &&
              familyMembers.map((member, index) => (
                <div key={index}>
                  <h4 style={{ marginTop: "30px", marginBottom: "10px" }}>
                    Traveler {index + 2}
                  </h4>
                  <div className="grid-two">
                    <div className="custom-input" style={{ width: "100%" }}>
                      <label className="input-label">Boarding pass</label>
                      <input
                        type="file"
                        onChange={(e) => {
                          handleBoardingUpload(e, index);
                          handleFamilyFileChange(e, index, "boarding");
                        }}
                        accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,.webp"
                        className="hidden"
                        id={`boarding-${index}`}
                      />
                      <div
                        onClick={() =>
                          document.getElementById(`boarding-${index}`).click()
                        }
                        className="input-box"
                        style={{
                          color:
                            getSubClaimFileName(
                              index,
                              "boarding_pass_file_name"
                            ) !== "Upload File"
                              ? "#222222"
                              : "#7b8287",
                        }}
                      >
                        {getSubClaimFileName(index, "boarding_pass_file_name")}
                        {/* {familyFileNames[index]?.boarding || "Upload file"} */}
                        <UploadIcon />
                      </div>
                    </div>
                    <div className="custom-input" style={{ width: "100%" }}>
                      <label className="input-label">Passport <span style={{ color: "#de8385" }}>*</span></label>
                      <input
                        type="file"
                        onChange={(e) => {
                          handlePassportUpload(e, index);
                          handleFamilyFileChange(e, index, "passport");
                        }}
                        accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,.webp"
                        className="hidden"
                        id={`passport-${index}`}
                      />
                      <div
                        onClick={() =>
                          document.getElementById(`passport-${index}`).click()
                        }
                        className="input-box"
                        style={{
                          color:
                            getSubClaimFileName(index, "passport_file_name") !==
                              "Upload File"
                              ? "#222222"
                              : "#7b8287",
                        }}
                      >
                        {getSubClaimFileName(index, "passport_file_name")}
                        {/* {familyFileNames[index]?.passport || "Upload file"} */}
                        <UploadIcon />
                      </div>
                    </div>
                  </div>
                  <div className="grid-two">
                    <div className="custom-input" style={{ width: "100%" }}>
                      <label className="input-label">
                        {(type_of_claim === "lost/damaged" || type_of_claim === "lost_wages") ? "Claim supporting documents and recipts" : "Additional claims documents"}
                      </label>
                      <input
                        type="file"
                        onChange={(e) => {
                          handleAdditionalUpload(e, index);
                          handleFamilyFileChange(e, index, "additional");
                        }}
                        accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,.webp"
                        className="hidden"
                        id={`additional-${index}`}
                      />
                      <div
                        onClick={() =>
                          document.getElementById(`additional-${index}`).click()
                        }
                        className="input-box"
                        style={{
                          color:
                            getSubClaimFileName(
                              index,
                              "addtional_file_name"
                            ) !== "Upload File"
                              ? "#222222"
                              : "#7b8287",
                        }}
                      >
                        {getSubClaimFileName(index, "addtional_file_name")}
                        {/* {familyFileNames[index]?.additional || "Upload file"} */}
                        <UploadIcon />
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-md-2">
                    <Button
                      color="danger"
                      size="sm"
                      onClick={() => removeFamilyMember(index)}
                      style={{ marginTop: "30px" }}
                    >
                      Remove
                    </Button>
                  </div> */}
                </div>
              ))}
            {/* <h4
              className="stepper-sub-sub-header"
              style={{ marginTop: "30px" }}
            >
              We recommend creating an account to track your claim status and in
              case if you want to upload any missing documents later.
            </h4> */}
          </div>
        </div>
      </form>
    </div>
  );
};

export default UploadRequiredDocument;
